import {
  LABEL_PROPERTY_PRESERVE_RATE_SELECTION,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigCheckbox from './ConfigCheckbox.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  EMPTY_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'
import {SHIPPER_VENDORS} from '../../../common/constants/ShipperNames.js'

export default function PreserveRateSelection() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = PreserveRateSelection.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigCheckbox
      label="Preserve Rate Selection"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

PreserveRateSelection.propertySpecList = [
  {
    validShipperTypes: SHIPPER_VENDORS,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY_PRESERVE_RATE_SELECTION]
    },
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
